import { useContext } from 'react';

import {
  ACTION_TYPE_ADD_TAG,
  ACTION_TYPE_INSURE_PACKAGE,
  ACTION_TYPE_REQUEST_CONFIRMATION,
  ACTION_TYPE_SET_SHIP_FROM_LOCATION,
  ACTION_TYPE_USE_PACKING_SLIP,
} from '../../constants/action-types';
import { FilterEditorContext } from '../../../../../components/filter-editor/context';
import { GuidService } from 'ui-components/services/guid-service';

import { useOpenRuleDrawer } from '../../hooks/use-open-rule-drawer';
import { useAiRuleCreatorFilterMapping } from './use-ai-rule-creator-filter-mapping';

// Action types whose UI components read from intParameter (number), not parameter (string)
const INT_PARAMETER_ACTION_TYPES = [
  ACTION_TYPE_ADD_TAG,
  ACTION_TYPE_INSURE_PACKAGE,
  ACTION_TYPE_REQUEST_CONFIRMATION,
  ACTION_TYPE_SET_SHIP_FROM_LOCATION,
  ACTION_TYPE_USE_PACKING_SLIP,
];

export const useModalRuleProcessor = () => {
  const openRuleDrawer = useOpenRuleDrawer();

  const { getNewTemporaryFilter } = useContext(FilterEditorContext);
  const { categorizeFilters } = useAiRuleCreatorFilterMapping();

  const convertGeneratedRuleToModalFormat = (generatedRule) => {
    const orderRuleActions =
      generatedRule.orderRuleActions?.map((action) => {
        const { actionTypeId } = action;
        let parameter = action.parameter ? action.parameter.trim() : null;
        let intParameter = action.intParameter ?? null;

        if (INT_PARAMETER_ACTION_TYPES.includes(actionTypeId)) {
          // These actions need intParameter. If LLM put value in parameter, move it.
          if (intParameter == null && parameter != null) {
            const parsed = Number.parseInt(parameter, 10);
            if (!Number.isNaN(parsed)) {
              intParameter = parsed;
              parameter = null;
            }
          }
          if (intParameter != null) {
            intParameter = Number(intParameter);
          }
        }

        return {
          actionTypeId,
          orderRuleActionId: GuidService.newGuid(),
          parameter,
          intParameter,
          isDeleted: false,
        };
      }) || [];

    return {
      active: generatedRule.active ?? true,
      orderRuleActions,
      isNew: true,
      isAiGenerated: true,
    };
  };

  const processGeneratedRule = (suggestedRule, existingRuleId) => {
    const modalRule = convertGeneratedRuleToModalFormat(suggestedRule);

    if (existingRuleId) {
      modalRule.automationRuleId = existingRuleId;
      modalRule.isNew = false;
    }

    let filterId;
    let filterSet = null;
    if (suggestedRule.filterCriteria?.conditions?.length > 0) {
      filterId = getNewTemporaryFilter();
      const categorizedFilters = categorizeFilters(suggestedRule.filterCriteria.conditions);
      filterSet = { orderFilterSetId: filterId, appliedFilters: categorizedFilters };
    }

    openRuleDrawer({
      rule: { ...modalRule, filterId },
      name: suggestedRule.name,
      filterSet,
    });
  };

  return {
    processGeneratedRule,
    convertGeneratedRuleToModalFormat,
  };
};
